import { BidPackOriginRegion } from "./BidPackOriginRegion";
import { BidPackDestination } from "./BidPackDestination";

export const bidPackObjectName = "Bid Pack";

export interface BidPack {
  Id: number;
  Name: string;
  StartDate: Date | null;
  EndDate?: Date | null;
  EquipmentIds: Array<number>;
  DestinationName: string;
  Destinations: Array<BidPackDestination>;
  OriginRegions: Array<BidPackOriginRegion>;
  TransportType: number;
}

export const defaultBidPack: BidPack = {
  Id: 0,
  Name: "",
  StartDate: null,
  EndDate: null,
  EquipmentIds: [],
  DestinationName: "",
  Destinations: [],
  OriginRegions: [],
  TransportType: 0,
};
